import { Component, Input, inject } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, of } from "rxjs";
import { ICstListViewState } from "src/app/common-components/list-view/models";
import { ITileGridTile } from "src/app/common-components/tile-grid/tile-grid.component";

export interface IAdminPageItem {
  label: string;
  routerLink: string;
  icon?: string;
}

@Component({
    selector: "app-admin-api-page",
    templateUrl: "./admin-api-page.component.html",
    styleUrls: ["./admin-api-page.component.scss"],
    standalone: false
})
export class AdminApiPageComponent {
  private _router = inject(Router);
  private _route = inject(ActivatedRoute);

  @Input() header = "";
  @Input() items: IAdminPageItem[] = [];

  onFetchData(
    _: ICstListViewState
  ): Observable<{ data: ITileGridTile[]; total: number }> {
    const data: ITileGridTile[] = this.items.map((x) => ({
      label: x.label,
      icon: x.icon,
      data: x.routerLink,
    }));
    return of({ data: data, total: data.length });
  }

  public canTileClick(tile: ITileGridTile) {
    return typeof tile.data === "string" && tile.data.length > 0;
  }
  public onTileClick(tile: ITileGridTile) {
    this._router.navigate([tile.data], { relativeTo: this._route });
  }
}
